import React, {useRef} from 'react';
import _ from "lodash";
import createLink from "../../../../libs/createLink";
import {useBreakpoint} from '../../../../libs/breakpoint';
import Dropdown from "../../Dropdown";
import Icon from "../../Icon";
import {NavLink} from "react-router-dom";
import {useQueryClient} from "@tanstack/react-query";
import {USER_CURRENT_KEY} from "../../../../api/public-voissa/users";


const SubNavBar = () => {
    const breakpoints = useBreakpoint();
    let isMbileSmall = !!breakpoints.xs;
    let isMobile = !!breakpoints.sm;
    let isLgDesktop = !!breakpoints.lg;
    let isTablette = !!breakpoints.md;
    let source = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "";

    const refDropdown = useRef();

    const queryClient = useQueryClient();

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isCurrentUser = !!_.get(dataCurrentUser, '_id');

    const linkMenu = [
        {
            to : createLink('photos'),
            label : "PHOTOS",
            icon : {
                type : "picture-c",
                className : "picto-c"
            },
            iconHover : {
                type : "picture-bw",
                className : "picto"
            },
            className : "picture-ico",
            exact : true,
            showMini : true,
            display : true
        },
        {
            to : createLink('videos'),
            label : "VIDEOS",
            icon : {
                type : "film-reel",
                className : "picto-c"
            },
            iconHover : {
                type : "film-reel-bw",
                className : "picto"
            },
            className : "film-ico",
            exact : true,
            showMini : true,
            display : true
        },
        {
            to : createLink('forum'),
            label : "FORUM",
            icon : {
                type : "forum-c",
                className : "picto-c"
            },
            iconHover : {
                type : "forum-bw",
                className : "picto"
            },
            className : "forum-ico",
            exact : true,
            showMini : false,
            display : true
        },
        /*{
            to : createLink('articles'),
            label : "ARTICLES",
            icon : {
                type : "article-c",
                className : "picto-c"
            },
            iconHover : {
                type : "article-bw",
                className : "picto"
            },
            className : "article-ico",
            exact : true,
            showMini : false,
            display : true
        },*/
        {
            to : `${createLink('comparatorDating')}?source=${isMobile ? "tab-mobile" : "tab-desktop"}`,
            label : "RENCONTRE",
            icon : {
                type : "meet-c",
                className : "picto-c"
            },
            iconHover : {
                type : "meet-bw",
                className : "picto"
            },
            className : `meet-ico`,
            exact : true,
            showMini : true,
            display : ["", "voissa"].includes(source)
        },
        {
            to : createLink('stories'),
            label : "HISTOIRES",
            icon : {
                type : "book-c",
                className : "picto-c"
            },
            iconHover : {
                type : "book",
                className : "picto"
            },
            className : "meet-ico",
            exact : true,
            showMini : false,
            display : true
        },
        {
            to : `${createLink('webcams')}?source=${isMobile ? "tab-mobile" : "tab-desktop"}`,
            label : "WEBCAMS",
            icon : {
                type : "video-camera-c",
                className : "picto-c"
            },
            iconHover : {
                type : "video-camera",
                className : "picto"
            },
            className : "meet-ico",
            exact : true,
            showMini : true,
            display : true
        },
        {
            href : "https://voissa.boutique",
            label : "BOUTIQUE",
            icon : {
                type : "shopping-cart-c",
                className : "picto-c"
            },
            iconHover : {
                type : "shopping-cart",
                className : "picto"
            },
            className : "meet-ico",
            exact : true,
            showMini : false,
            display : true
        }
    ];

    let menuShow = linkMenu.filter(item => item.display);
    let menuHide = [];
    if(isMbileSmall){
        let menuSort = _.orderBy(linkMenu, ['showMini'], ['desc']);
        let limit = isCurrentUser ? 2 : 3;
        menuShow = menuSort.filter(item => item.showMini && item.display).slice(0,limit);
        menuHide = menuSort.filter(item => item.display).slice(menuShow.length);
    }

    else if(isMobile){
        let menuSort = _.orderBy(linkMenu, ['showMini'], ['desc']);
        let limit = isCurrentUser ? 3 : 4;
        menuShow = menuSort.filter(item => item.showMini && item.display).slice(0,limit);
        menuHide = menuSort.filter(item => item.display).slice(menuShow.length);
    }
    else if(isTablette){
        let menuSort = _.orderBy(linkMenu, ['showMini'], ['desc']);
        let limit = isCurrentUser ? 4 : 5;
        menuShow = menuSort.filter(item => item.display).slice(0,limit);
        menuHide = menuSort.filter(item => item.display).slice(limit);
    }
    else if(isLgDesktop){
        menuShow = linkMenu.filter(item => item.display);
        menuHide = []
    }


    return (
        <nav className={isTablette ? "mobile-header-menu" : ""}>
            <div className="navbar container">
                <ul className={isTablette ? "menu-row" : ""}>
                    <li className={"link-home"}><NavLink
                        className="link"
                        to="/"
                        //activeClassName="active"
                    >
                        <div className="row picto-container home-ico">
                            <Icon type="home-c" className="picto-c"/>
                            <Icon type="home-bw" className="picto"/></div>
                        ACCUEIL
                    </NavLink>
                    </li>
                    {isCurrentUser && (
                        <li><NavLink
                            className="link" to={createLink('actuality')}
                            //activeClassName="active"
                        >
                            <div className="row picto-container timeline-ico"><Icon type="timeline-c"
                                                                                    className="picto-c"/><Icon
                                type="timeline-bw" className="picto"/></div>
                            MON RÉSEAU</NavLink>
                        </li>
                    )}
                    {menuShow.map(item =>(
                        <li key={item.label} >{item.to ? <NavLink
                            className="link"
                            to={item.to}
                            //exact={item.exact}
                            //activeClassName="active"
                        >
                            <div className={`row picto-container ${item.className}`}>
                                <Icon {...item.icon} />
                                <Icon {...item.iconHover}/>
                            </div>
                            {item.label}
                        </NavLink> : <a
                            href={item.href}
                            className="link"
                            rel="nofollow noopener noreferrer"
                            target={"_blank"}>
                            <div className={`row picto-container ${item.className}`}>
                                <Icon {...item.icon} />
                                <Icon {...item.iconHover}/>
                            </div>
                            {item.label}
                        </a>}
                        </li>
                    ))}
                    {menuHide.length ? (
                        <Dropdown align={"absolute"} ref={refDropdown}  activableComponent={(
                            <li>+</li>
                        )}>
                            <ul className="dropdown-menu">
                                {menuHide.map(item =>(

                                    item.to ? <NavLink key={item.label} to={item.to} className="menu-item" onClick={() => refDropdown?.current?.handleCloseDropdownParent()} >
                                        <li>
                                            <Icon type={item.icon.type}/> {item.label}
                                        </li>
                                    </NavLink> :
                                    <a key={item.label} href={item.href} className="menu-item" rel="nofollow noopener noreferrer" target={"_blank"} onClick={() => refDropdown?.current?.handleCloseDropdownParent()} >
                                        <li >
                                           <Icon type={item.icon.type}/> {item.label}
                                        </li>
                                    </a>
                                ))}
                            </ul>
                        </Dropdown>
                    ) : null}
                </ul>

            </div>
        </nav>
    )
}

export default SubNavBar;